import { Controller } from "@hotwired/stimulus"

// Connects to data-controller="header-search"
export default class extends Controller {
  static targets = ["form", "input"]

  connect() {
    this.isOpen = false
  }

  toggle(event) {
    event.preventDefault()
    
    if (this.isOpen) {
      // If form is open and has input value, submit the form
      if (this.inputTarget.value.trim()) {
        this.formTarget.submit()
        return
      }
      
      // Otherwise close the form with animation
      this.formTarget.classList.add('slide-out')
      this.formTarget.classList.remove('slide-in')
      
      // Remove show class after animation completes
      setTimeout(() => {
        this.formTarget.classList.remove('show')
        this.formTarget.classList.remove('slide-out')
      }, 300)
      
    } else {
      // Open the form with animation
      this.formTarget.classList.add('show', 'slide-in')
      setTimeout(() => {
        this.inputTarget.focus()
      }, 100)
    }
    
    this.isOpen = !this.isOpen
  }
}
